import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';
import { getAnalytics } from 'firebase/analytics';

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyBC58H7wsUVdLXyRDt__g2cEknfvPsPHK4",
  authDomain: "jkprints-d58cf.firebaseapp.com",
  projectId: "jkprints-d58cf",
  storageBucket: "jkprints-d58cf.firebasestorage.app",
  messagingSenderId: "555426902517",
  appId: "1:555426902517:web:da443f3c936742a626b0bc",
  measurementId: "G-QR68JH0L5R"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);

// Export Firebase services
export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);

export default app;
export { analytics };
